import React from 'react'
import cn from "classnames"
import PropTypes from 'prop-types'
import injectStyles from "react-jss"
import CategoryLabel from './CategoryLabel'
import ArticleTime from '../Article/ArticleTime'

const CategoryLabelAndTime = ({classes, className, article, color, showArticleTime = true, showYear = true, size, dividerSpacing}) => (
    <div className={cn(classes.categoryContainer, className)} data-cy="categoryLabelAndTime">
        <CategoryLabel color={color} category={article.category || article.type} tags={article.tags} size={size}/>
        {showArticleTime &&
            <ArticleTime key='time' article={article} startWithDivider={true} variation={size} dividerSpacing={dividerSpacing} showYear={showYear} />
        }
    </div>
)

CategoryLabelAndTime.propTypes = {
    article: PropTypes.object.isRequired,
}

export default injectStyles(theme => ({
    categoryContainer: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '16px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        maxWidth: 'auto',
        [theme.breakpoint("tablet")]: {
            maxWidth: 1308
        }
    },
}))(CategoryLabelAndTime)





// WEBPACK FOOTER //
// ./src/components/Widgets/CategoryLabelAndTime.js